export default __webpack_public_path__ + "static/media/location.1ec040d6.svg";